import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
// import ReactTooltip from 'react-tooltip';

class Steps extends Component {

    render() {
        return (
            <div className="row form-steps">
                {this.props.step_array.map((item,i) => {
                    if (item.link && this.props.step !== (i+1)) {
                        return (
                            <div key={i} className={"" + (this.props.step === (i+1) ? 'active' : 'inactive')}>
                            <NavLink to={item.link}>
                                {i+1}. {item.step_name}
                            </NavLink>
                            </div>
                        );
                    } else {
                        return (
                            <div key={i} className={"" + (this.props.step === (i+1) ? 'active' : 'inactive')}>
                                <span>{i+1}. {item.step_name}</span>
                            </div>
                        );
                    }   
                })}
                {/*
                <div className={"" + (this.props.step === 1 ? 'active' : '')}>
                {(this.props.step_links && this.props.step_links[this.props.step]) ?
                    <NavLink to={this.props.step_links[this.props.step]}>
                        <span>1. Description</span>
                    </NavLink>
                    :
                    <span>1. Description</span>
                }
                </div>
                <div className={"" + (this.props.step === 2 ? 'active' : '')}>
                    2. Images</div>
                <div className={"" + (this.props.step > 2 ? 'active' : '')}>
                    3. Audio</div>
                    */}
            </div>
        )
    }
}

export default Steps;
